import Mainvisual from "./_mainvisual.es6";
import { Param } from "../common/util/param.es6";

export default class Loading {
    constructor() {
        this.isSp = true;
        this.init();
    }

    init() {
        this.mainvisual = new Mainvisual();
        this._setBp();

        window.onresize = () => {
            this._setBp();
        };

        window.addEventListener("load", () => {
            document.body.classList.add("-loadingend");
        });

        this.showMainvisual();
    }

    _setBp() {
        const mediaQuery = window.matchMedia("(max-width: 1019px)");
        // イベントリスナーを登録

        mediaQuery.addListener((e) => {
            this._handleTabletChange(e);
        });

        this._handleTabletChange(mediaQuery);
    }

    _handleTabletChange(e) {
        if (e.matches) {
            this.isSp = true;
        } else {
            this.isSp = false;
        }
    }

    showMainvisual() {
        if (!this.isSp) {
            const trigger = document.querySelector(".decotxt__inner");

            trigger.addEventListener("animationend", () => {
                setTimeout(() => {
                    var url = document.referrer;
                    var results = url.match(/news/);

                    if (Param("nointro")) {
                        return;
                    }

                    if (!results) {
                    } else {
                        return;
                    }

                    if (window.performance) {
                        if (window.performance.navigation.type === 1) {
                            return;
                        }
                    }

                    //this.mainvisual._scrollIntro();
                }, 500);
            });
        }

        //this.openMovie();
    }

    openMovie() {
        const mobiebtn = document.querySelector(".movie .js-modal_movie_open");
        const mvecotxt = document.querySelector(".decotxt__inner");

        mvecotxt.addEventListener("animationend", () => {
            setTimeout(() => {
                mobiebtn.click();
            }, 500);
        });
    }
}
